import React from "react";
import "./App.css";
import { AuthProvider } from "./app/contexts/JWTAuthContext";
import RoutePage from "./features/config/routes/RoutePage";

function App() {
  return (
    <AuthProvider>
      <RoutePage />
    </AuthProvider>
  );
}

export default App;
